<sc-no-data-container fitHeight [hasData]="this.dataSource.filteredData.length >  0">

  <table class="truck-table mat-table-selection" mat-table [dataSource]="dataSource" matSort matSortActive="{{sortColumn}}"
    [matSortDirection]="sortDirection">

    <ng-container matColumnDef="driver">
      <th mat-header-cell mat-sort-header *matHeaderCellDef>
        <sc-dictionary-label dictionaryKey="tmc.visit.overview.trucks.table.column.driver"></sc-dictionary-label>
      </th>
      <td mat-cell class="text-selection" *matCellDef="let visit"> {{visit.driver}} </td>
    </ng-container>

    <ng-container matColumnDef="coDriver">
      <th mat-header-cell mat-sort-header *matHeaderCellDef>
        <sc-dictionary-label dictionaryKey="tmc.visit.overview.trucks.table.column.coDriver"></sc-dictionary-label>
      </th>
      <td mat-cell class="text-selection" *matCellDef="let visit"> {{visit.coDriver}} </td>
    </ng-container>

    <ng-container matColumnDef="carrier">
      <th mat-header-cell mat-sort-header *matHeaderCellDef>
        <sc-dictionary-label dictionaryKey="tmc.visit.overview.trucks.table.column.carrier"></sc-dictionary-label>
      </th>
      <td mat-cell class="text-selection" *matCellDef="let visit"> {{visit.carrier}} </td>
    </ng-container>

    <ng-container matColumnDef="supplier">
      <th mat-header-cell mat-sort-header *matHeaderCellDef>
        <sc-dictionary-label dictionaryKey="tmc.visit.overview.trucks.table.column.supplier"></sc-dictionary-label>
      </th>
      <td mat-cell class="text-selection" *matCellDef="let visit"> {{visit.supplier}} </td>
    </ng-container>

    <ng-container matColumnDef="numberPlate">
      <th mat-header-cell mat-sort-header *matHeaderCellDef>
        <sc-dictionary-label dictionaryKey="tmc.visit.overview.trucks.table.column.numberPlate"></sc-dictionary-label>
      </th>
      <td mat-cell class="text-selection" *matCellDef="let visit"> {{visit.numberPlate}} </td>
    </ng-container>

    <ng-container matColumnDef="registration">
      <th mat-header-cell mat-sort-header *matHeaderCellDef>
        <sc-dictionary-label dictionaryKey="tmc.visit.overview.trucks.table.column.registration"></sc-dictionary-label>
      </th>
      <td mat-cell class="text-selection" *matCellDef="let visit"> {{visit.registration}} </td>
    </ng-container>

    <ng-container matColumnDef="filler">
      <th mat-header-cell *matHeaderCellDef style="width: 100%;"> &nbsp; </th>
      <td mat-cell *matCellDef="let transport"> &nbsp;</td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true"></tr>

    <tr mat-row *matRowDef="let visit; columns: columnsToDisplay" [ngClass]="getRowStyles(visit)"
      (click)="toggleSelection(visit)"></tr>


  </table>

</sc-no-data-container>
